/**
 * Insieme delle strategie di autenticazione attive, derivato dalla env
 * AUTH_STRATEGIES (lista separata da virgole). Calcolato una sola volta al
 * load del modulo: il valore è sostituito da DefinePlugin a build-time.
 */
const authStrategies = new Set(
  (process.env.AUTH_STRATEGIES ?? '')
    .split(',')
    .map(strategy => strategy.trim())
    .filter(Boolean),
);

/**
 * Verifica se una strategia di autenticazione è attiva, ossia se il suo
 * identificativo è presente in AUTH_STRATEGIES.
 */
export function isAuthStrategyEnabled(strategy: string): boolean {
  return authStrategies.has(strategy);
}
